module.exports = __webpack_public_path__ + "img/162.e18e4a75.jpg";